// ================================================================
// PRESCRICOES.JS - Gerenciamento de Prescrições Agronômicas
// Sprint 2 - Versão funcional completa
// ================================================================

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.operacional = window.FazendaRP.Pages.operacional || {};

window.FazendaRP.Pages.operacional.prescricoes = {
    container: null,
    activeSubTab: 'ativas', // 'ativas', 'executadas', 'arquivadas'

    render: async function (container) {
        this.container = container;

        // Load variedades first
        const shared = window.FazendaRP.Pages.operacional.shared;
        await shared.populateSafras();
        await shared.loadVariedades(shared.safraAtual);

        const html = `
            <div style="background: white; border-radius: 12px; padding: 25px; box-shadow: 0 2px 8px rgba(0,0,0,0.06);">
                <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
                    <div style="display:flex; align-items:center; gap:20px;">
                        <h3 style="margin:0; color:#1f2937;">
                            <i class="fas fa-clipboard-check" style="color:#059669;"></i> Prescrições Agronômicas
                        </h3>
                        
                        <!-- Safra Selector -->
                        <div style="display:flex; align-items:center; gap:10px;">
                            <label style="font-size:0.9rem; color:#6b7280; font-weight:600;">
                                <i class="fas fa-seedling" style="color:#059669;"></i> Safra:
                            </label>
                            <select id="safra-selector-prescricoes" style="padding:8px 12px; border:1px solid #d1d5db; border-radius:6px; font-size:0.9rem; cursor:pointer; background:white;">
                                ${shared.safraOptionsHtml || `<option value="${shared.safraAtual}">${shared.safraAtual}</option>`}
                            </select>
                        </div>
                    </div>
                    
                    <div style="display:flex; gap:10px;">
                        <button onclick="window.FazendaRP.Pages.operacional.exports.exportPrescricoesExcel()" 
                                style="background:#10b981; color:white; border:none; padding:10px 16px; border-radius:8px; font-weight:600; cursor:pointer; display:flex; align-items:center; gap:6px;">
                            <i class="fas fa-file-excel"></i> Excel
                        </button>
                        <button id="btn-nova-prescricao" style="background:#059669; color:white; border:none; padding:10px 20px; border-radius:8px; font-weight:600; cursor:pointer;">
                            <i class="fas fa-plus-circle"></i> Nova Prescrição
                        </button>
                    </div>
                </div>

                <!-- Sub-tabs -->
                <div style="display:flex; gap:15px; border-bottom:2px solid #e5e7eb; margin-bottom:20px;">
                    <button class="subtab-btn ${this.activeSubTab === 'ativas' ? 'active' : ''}" data-tab="ativas" style="background:none; border:none; padding:10px 15px; font-weight:600; cursor:pointer; border-bottom:3px solid ${this.activeSubTab === 'ativas' ? '#059669' : 'transparent'}; color:${this.activeSubTab === 'ativas' ? '#059669' : '#6b7280'};">
                        Ativas
                    </button>
                    <button class="subtab-btn ${this.activeSubTab === 'executadas' ? 'active' : ''}" data-tab="executadas" style="background:none; border:none; padding:10px 15px; font-weight:600; cursor:pointer; border-bottom:3px solid ${this.activeSubTab === 'executadas' ? '#059669' : 'transparent'}; color:${this.activeSubTab === 'executadas' ? '#059669' : '#6b7280'};">
                        Executadas
                    </button>
                    <button class="subtab-btn ${this.activeSubTab === 'arquivadas' ? 'active' : ''}" data-tab="arquivadas" style="background:none; border:none; padding:10px 15px; font-weight:600; cursor:pointer; border-bottom:3px solid ${this.activeSubTab === 'arquivadas' ? '#059669' : 'transparent'}; color:${this.activeSubTab === 'arquivadas' ? '#059669' : '#6b7280'};">
                        Arquivadas
                    </button>
                </div>

                <div id="prescricoes-content">
                    <div style="text-align:center; padding:40px; color:#9ca3af;">
                        <i class="fas fa-circle-notch fa-spin"></i> Carregando prescrições...
                    </div>
                </div>

                <!-- Modal Form (hidden by default) -->
                <div id="modal-prescricao" style="display:none; position:fixed; top:0; left:0; right:0; bottom:0; background:rgba(0,0,0,0.5); z-index:9999; overflow-y:auto;">
                    <div style="min-height:100vh; display:flex; align-items:center; justify-content:center; padding:20px;">
                        <div style="background:white; border-radius:12px; max-width:900px; width:100%; max-height:90vh; overflow-y:auto;">
                            <div id="form-prescricao-container"></div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        container.innerHTML = html;
        this.setupEvents();
        this.loadPrescricoes();
    },

    setupEvents: function () {
        // Safra selector
        const safraSelector = document.getElementById('safra-selector-prescricoes');
        if (safraSelector) {
            safraSelector.addEventListener('change', async (e) => {
                const novaSafra = e.target.value;
                console.log(`🔄 Mudando para safra: ${novaSafra}`);

                const shared = window.FazendaRP.Pages.operacional.shared;
                shared.variedadesCache = [];
                await shared.loadVariedades(novaSafra);

                // Reload prescricoes
                this.loadPrescricoes();

                console.log(`✅ Safra alterada para: ${novaSafra}`);
                window.FazendaRP.Toast?.show('success', 'Safra Alterada', `Agora trabalhando com safra ${novaSafra}`);
            });
        }

        // Nova Prescrição button
        const btnNova = document.getElementById('btn-nova-prescricao');
        if (btnNova) {
            btnNova.addEventListener('click', () => this.abrirFormNova());
        }

        // Sub-tabs
        document.querySelectorAll('.subtab-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                this.activeSubTab = e.target.dataset.tab;
                this.render(this.container);
            });
        });
    },

    loadPrescricoes: async function () {
        const content = document.getElementById('prescricoes-content');
        if (!content) return;

        try {
            let query = window.FazendaRP.supabase
                .from('operacional_prescricoes')
                .select('*')
                .order('data_inicio', { ascending: false });

            // Filter by status based on active tab
            if (this.activeSubTab === 'ativas') {
                query = query.in('status', ['Pendente', 'Aprovada']);
            } else if (this.activeSubTab === 'executadas') {
                query = query.eq('status', 'Executada');
            } else if (this.activeSubTab === 'arquivadas') {
                query = query.in('status', ['Cancelada', 'Vencida']);
            }

            const { data, error } = await query;

            if (error) throw error;

            if (!data || data.length === 0) {
                content.innerHTML = `
                    <div style="text-align:center; padding:60px; background:#f9fafb; border-radius:12px; border:2px dashed #e5e7eb;">
                        <i class="fas fa-clipboard-list" style="font-size:3rem; color:#d1d5db; margin-bottom:15px;"></i>
                        <h4 style="margin:0; color:#4b5563;">Nenhuma prescrição ${this.activeSubTab}</h4>
                        <p style="color:#9ca3af; margin-top:5px;">Clique em "Nova Prescrição" para começar.</p>
                    </div>
                `;
                return;
            }

            const html = data.map(p => this.renderPrescricaoCard(p)).join('');
            content.innerHTML = html;

        } catch (err) {
            console.error(err);
            content.innerHTML = '<div style="color:red; text-align:center; padding:20px;">Erro ao carregar prescrições</div>';
        }
    },

    renderPrescricaoCard: function (prescricao) {
        const shared = window.FazendaRP.Pages.operacional.shared;
        const dataRange = shared.formatDateRange(prescricao.data_inicio, prescricao.data_fim);

        // Status colors
        const statusColors = {
            'Pendente': '#f59e0b',
            'Aprovada': '#3b82f6',
            'Executada': '#10b981',
            'Cancelada': '#6b7280',
            'Vencida': '#ef4444'
        };

        const color = statusColors[prescricao.status] || '#6b7280';

        // Action buttons based on status
        let actions = '';
        if (prescricao.status === 'Pendente' || prescricao.status === 'Aprovada') {
            actions = `
                <button onclick="window.FazendaRP.Pages.operacional.prescricoes.executarPrescricao('${prescricao.id}')" style="background:#059669; color:white; border:none; padding:8px 16px; border-radius:6px; font-weight:600; cursor:pointer; font-size:0.85rem;">
                    <i class="fas fa-play"></i> Executar
                </button>
                <button onclick="window.FazendaRP.Pages.operacional.prescricoes.cancelarPrescricao('${prescricao.id}')" style="background:#ef4444; color:white; border:none; padding:8px 16px; border-radius:6px; font-weight:600; cursor:pointer; font-size:0.85rem;">
                    <i class="fas fa-times"></i> Cancelar
                </button>
            `;
        }

        // PDF button always visible
        actions += `
            <button onclick="window.FazendaRP.Pages.operacional.prescricoes.exportarPDF('${prescricao.id}')" style="background:#dc2626; color:white; border:none; padding:8px 16px; border-radius:6px; font-weight:600; cursor:pointer; font-size:0.85rem;">
                <i class="fas fa-file-pdf"></i> PDF
            </button>
        `;

        return `
            <div style="background:white; border-left:4px solid ${color}; padding:20px; border-radius:10px; margin-bottom:15px; box-shadow:0 1px 3px rgba(0,0,0,0.05);">
                <div style="display:flex; justify-content:space-between; align-items:start; margin-bottom:15px;">
                    <div style="flex:1;">
                        <div style="display:flex; align-items:center; gap:10px; margin-bottom:8px;">
                            <h4 style="margin:0; color:#1f2937;">${prescricao.titulo}</h4>
                            <span style="background:${color}; color:white; padding:4px 12px; border-radius:12px; font-size:0.75rem; font-weight:700;">
                                ${prescricao.status}
                            </span>
                        </div>
                        <div style="color:#6b7280; font-size:0.9rem; margin-bottom:10px;">
                            <i class="fas fa-calendar"></i> <strong>Janela:</strong> ${dataRange}
                            <span style="margin-left:20px;">
                                <i class="fas fa-seedling"></i> <strong>Operação:</strong> ${prescricao.tipo_operacao}
                            </span>
                        </div>
                        ${prescricao.estadio_fenologico ? `
                            <div style="color:#6b7280; font-size:0.85rem;">
                                <i class="fas fa-leaf"></i> <strong>Estádio:</strong> ${prescricao.estadio_fenologico}
                            </div>
                        ` : ''}
                    </div>
                    <div style="display:flex; gap:8px;">
                        ${actions}
                    </div>
                </div>
                
                ${prescricao.objetivo ? `
                    <div style="background:#f9fafb; padding:12px; border-radius:6px; margin-bottom:10px;">
                        <strong style="color:#374151; font-size:0.85rem;">Objetivo:</strong>
                        <p style="margin:5px 0 0 0; color:#6b7280; font-size:0.85rem;">${prescricao.objetivo}</p>
                    </div>
                ` : ''}

                ${prescricao.insumos && prescricao.insumos.length > 0 ? `
                    <div style="margin-top:10px;">
                        <strong style="color:#374151; font-size:0.85rem;">Produtos:</strong>
                        <div style="display:flex; flex-wrap:wrap; gap:8px; margin-top:5px;">
                            ${prescricao.insumos.map(i => `
                                <span style="background:#ecfdf5; color:#065f46; padding:4px 12px; border-radius:12px; font-size:0.8rem;">
                                    ${i.item}: ${i.dose} ${i.unidade}
                                </span>
                            `).join('')}
                        </div>
                    </div>
                ` : ''}

                ${prescricao.custo_estimado && prescricao.custo_estimado > 0 ? `
                    <div style="margin-top:15px; padding:15px; background:linear-gradient(135deg, #ecfdf5, #d1fae5); border-radius:8px; border-left:4px solid #059669;">
                        <div style="display:flex; align-items:center; justify-content:space-between;">
                            <strong style="color:#065f46; font-size:1rem;">
                                💰 Custo Estimado
                            </strong>
                            <span style="color:#059669; font-size:1.3rem; font-weight:700;">
                                ${shared.formatCurrency(prescricao.custo_estimado)}
                            </span>
                        </div>
                        ${prescricao.area_total_ha ? `
                            <div style="color:#6b7280; font-size:0.8rem; margin-top:5px;">
                                ${shared.formatCurrency(prescricao.custo_estimado / prescricao.area_total_ha)}/ha
                            </div>
                        ` : ''}
                    </div>
                ` : ''}
            </div>
        `;
    },

    abrirFormNova: function () {
        const modal = document.getElementById('modal-prescricao');
        const formContainer = document.getElementById('form-prescricao-container');

        if (!modal || !formContainer) return;

        formContainer.innerHTML = this.renderFormPrescricao();
        modal.style.display = 'block';

        // Setup close button
        document.getElementById('btn-fechar-modal')?.addEventListener('click', () => {
            modal.style.display = 'none';
        });

        // Click outside to close
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                modal.style.display = 'none';
            }
        });
    },

    renderFormPrescricao: function () {
        const shared = window.FazendaRP.Pages.operacional.shared;
        const today = new Date().toISOString().split('T')[0];

        // Check if varieties are loaded
        let variedadesCheckboxes = '';
        if (!shared.variedadesCache || shared.variedadesCache.length === 0) {
            variedadesCheckboxes = `
                <div style="padding:20px; text-align:center; background:#fff3cd; border:1px solid #ffc107; border-radius:8px; color:#856404;">
                    <i class="fas fa-exclamation-triangle" style="font-size:2rem; margin-bottom:10px; display:block;"></i>
                    <strong>Nenhuma variedade encontrada</strong>
                    <p style="margin:10px 0 0 0; font-size:0.9rem;">
                        Selecione a safra correta acima ou cadastre variedades em <strong>Sistema > Safras</strong>.
                    </p>
                </div>
            `;
        } else {
            variedadesCheckboxes = shared.variedadesCache.map(v => `
                <label style="display:inline-flex; align-items:center; gap:8px; padding:8px 12px; background:white; border:1px solid #d1d5db; border-radius:20px; cursor:pointer; margin:5px;">
                    <input type="checkbox" name="variedades_presc" value="${v.id}" data-area="${v.area_hectares}" style="accent-color:#059669;">
                    <span>${v.nome} (${v.area_hectares}ha)</span>
                </label>
            `).join('');
        }

        return `
            <form id="form-nova-prescricao" style="padding:30px;" onsubmit="window.FazendaRP.Pages.operacional.prescricoes.savePrescricao(event); return false;">
                <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:25px; padding-bottom:15px; border-bottom:2px solid #e5e7eb;">
                    <h3 style="margin:0; color:#1f2937;">
                        <i class="fas fa-file-medical" style="color:#059669;"></i> Nova Prescrição
                    </h3>
                    <button type="button" id="btn-fechar-modal" style="background:none; border:none; font-size:1.5rem; color:#6b7280; cursor:pointer;">
                        <i class="fas fa-times"></i>
                    </button>
                </div>

                <!-- Informações Básicas -->
                <div style="display:grid; grid-template-columns:2fr 1fr 1fr; gap:15px; margin-bottom:20px;">
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">Título da Prescrição *</label>
                        <input type="text" name="titulo" placeholder="Ex: Aplicação Herbicida Pós-Emergente" required style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px;">
                    </div>
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">Data Início *</label>
                        <input type="date" name="data_inicio" value="${today}" required style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px;">
                    </div>
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">Data Fim *</label>
                        <input type="date" name="data_fim" value="${today}" required style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px;">
                    </div>
                </div>

                <div style="display:grid; grid-template-columns:1fr 1fr; gap:15px; margin-bottom:20px;">
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">Tipo de Operação *</label>
                        <select name="tipo" required style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px;">
                            <option value="">-- Selecione --</option>
                            <option value="Pulverização">Pulverização</option>
                            <option value="Adubação">Adubação</option>
                            <option value="Dessecação">Dessecação</option>
                            <option value="Plantio">Plantio</option>
                        </select>
                    </div>
                    <div>
                        <label style="display:block; font-weight:600; margin-bottom:5px; font-size:0.9rem; color:#374151;">Estádio Fenológico</label>
                        <select name="estadio" style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:8px;">
                            <option value="">-- Não se aplica --</option>
                            <optgroup label="Vegetativo">
                                <option value="VE">VE - Emergência</option>
                                <option value="VC">VC - Cotilédones</option>
                                <option value="V1">V1 - 1ª Folha Trifoliada</option>
                                <option value="V2">V2 - 2ª Folha Trifoliada</option>
                                <option value="V3">V3 - 3ª Folha Trifoliada</option>
                                <option value="V4">V4 - 4ª Folha Trifoliada</option>
                                <option value="V5">V5 - 5ª Folha Trifoliada</option>
                                <option value="V6">V6 - 6ª Folha Trifoliada</option>
                                <option value="V7">V7 - 7ª Folha Trifoliada</option>
                                <option value="V8">V8 - 8ª Folha Trifoliada</option>
                                <option value="V9">V9 - 9ª Folha Trifoliada</option>
                                <option value="V10">V10 - 10ª Folha Trifoliada</option>
                                <option value="VN">VN - Última Folha Trifoliada</option>
                            </optgroup>
                            <optgroup label="Reprodutivo">
                                <option value="R1">R1 - Início Floração</option>
                                <option value="R2">R2 - Floração Plena</option>
                                <option value="R3">R3 - Início Formação Vagens</option>
                                <option value="R4">R4 - Vagens Desenvolvidas</option>
                                <option value="R5.1">R5.1 - Início Enchimento Grãos</option>
                                <option value="R5.2">R5.2 - Enchimento Grãos 25%</option>
                                <option value="R5.3">R5.3 - Enchimento Grãos 50%</option>
                                <option value="R5.4">R5.4 - Enchimento Grãos 75%</option>
                                <option value="R5.5">R5.5 - Enchimento Grãos 100%</option>
                                <option value="R6">R6 - Grãos Cheios</option>
                                <option value="R7">R7 - Maturação Fisiológica</option>
                                <option value="R8">R8 - Maturação de Colheita</option>
                                <option value="R9">R9 - Ponto de Colheita</option>
                            </optgroup>
                        </select>
                    </div>
                </div>

                <!-- Variedades -->
                <div style="background:#f9fafb; padding:20px; border-radius:10px; margin-bottom:20px; border:1px solid #e5e7eb;">
                    <label style="display:block; font-weight:700; margin-bottom:12px; color:#1f2937;">
                        <i class="fas fa-seedling" style="color:#059669;"></i> Aplicar em quais Variedades? *
                    </label>
                    <div style="display:flex; flex-wrap:wrap; gap:8px;">
                        ${variedadesCheckboxes}
                    </div>
                </div>

                <!-- Insumos -->
                <div style="background:#f0fdf4; padding:20px; border-radius:10px; margin-bottom:20px; border:2px dashed #059669;">
                    <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:15px;">
                        <label style="font-weight:700; color:#1f2937;">
                            <i class="fas fa-flask" style="color:#059669;"></i> Produtos/Insumos Prescritos
                        </label>
                        <button type="button" onclick="window.FazendaRP.Pages.operacional.prescricoes.addInsumoRow()" style="background:#059669; color:white; border:none; padding:8px 16px; border-radius:6px; font-weight:600; cursor:pointer; font-size:0.85rem;">
                            <i class="fas fa-plus"></i> Adicionar
                        </button>
                    </div>
                    <div id="insumos-presc-container">
                        <div style="text-align:center; padding:20px; color:#9ca3af; font-size:0.9rem;">
                            Nenhum produto adicionado
                        </div>
                    </div>
                </div>

                <!-- Objetivo Técnico -->
                <div style="margin-bottom:20px;">
                    <label style="display:block; font-weight:600; margin-bottom:8px; color:#374151;">Objetivo / Justificativa Técnica</label>
                    <textarea name="objetivo" rows="3" style="width:100%; padding:12px; border:1px solid #d1d5db; border-radius:8px; resize:vertical;" placeholder="Ex: Controle de plantas daninhas em pós-emergência..."></textarea>
                </div>

                <!-- Botões -->
                <div style="display:flex; gap:12px; justify-content:flex-end; padding-top:20px; border-top:2px solid #e5e7eb;">
                    <button type="button" onclick="document.getElementById('modal-prescricao').style.display='none'" style="background:#f3f4f6; color:#4b5563; border:1px solid #d1d5db; padding:12px 24px; border-radius:8px; font-weight:600; cursor:pointer;">
                        Cancelar
                    </button>
                    <button type="submit" style="background:linear-gradient(135deg, #059669, #047857); color:white; border:none; padding:12px 24px; border-radius:8px; font-weight:600; cursor:pointer; box-shadow:0 2px 4px rgba(5,150,105,0.3);">
                        <i class="fas fa-save"></i> Salvar Prescrição
                    </button>
                </div>
            </form>
        `;
    },

    calculateAreaTotal: function (variedadesIds) {
        const shared = window.FazendaRP.Pages.operacional.shared;
        return variedadesIds.reduce((sum, vid) => {
            const v = shared.variedadesCache.find(v => v.id === vid);
            return sum + (v ? parseFloat(v.area_hectares) : 0);
        }, 0);
    },

    addInsumoRow: function () {
        const container = document.getElementById('insumos-presc-container');
        if (!container) return;

        if (container.innerHTML.includes('Nenhum produto')) {
            container.innerHTML = '';
        }

        const rowId = 'insumo-presc-' + Date.now();
        const html = `
            <div id="${rowId}" style="background:white; padding:15px; border-radius:8px; margin-bottom:10px; border:1px solid #e5e7eb;">
                <div style="display:grid; grid-template-columns:2fr 1fr 1fr auto; gap:10px; align-items:end;">
                    <div>
                        <label style="display:block; font-size:0.8rem; font-weight:600; margin-bottom:5px; color:#6b7280;">Produto</label>
                        <input type="text" class="insumo-presc-nome" placeholder="Ex: Glifosato 480 g/L" required style="width:100%; padding:8px; border:1px solid #d1d5db; border-radius:6px;">
                    </div>
                    <div>
                        <label style="display:block; font-size:0.8rem; font-weight:600; margin-bottom:5px; color:#6b7280;">Dose/ha</label>
                        <input type="number" step="0.01" class="insumo-presc-dose" placeholder="2.5" required style="width:100%; padding:8px; border:1px solid #d1d5db; border-radius:6px;">
                    </div>
                    <div>
                        <label style="display:block; font-size:0.8rem; font-weight:600; margin-bottom:5px; color:#6b7280;">Unidade</label>
                        <select class="insumo-presc-unidade" style="width:100%; padding:8px; border:1px solid #d1d5db; border-radius:6px;">
                            <option value="L/ha">L/ha</option>
                            <option value="kg/ha">kg/ha</option>
                            <option value="g/ha">g/ha</option>
                        </select>
                    </div>
                    <div>
                        <button type="button" onclick="document.getElementById('${rowId}').remove()" style="background:#ef4444; color:white; border:none; padding:8px 12px; border-radius:6px; cursor:pointer;">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
        `;

        container.insertAdjacentHTML('beforeend', html);
    },

    savePrescricao: async function (e) {
        e.preventDefault();
        const form = e.target;
        const btn = form.querySelector('button[type="submit"]');

        btn.disabled = true;
        btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Salvando...';

        // Get variedades
        const variedades = [];
        form.querySelectorAll('input[name="variedades_presc"]:checked').forEach(c => variedades.push(c.value));

        if (variedades.length === 0) {
            alert('Selecione pelo menos uma variedade');
            btn.disabled = false;
            btn.innerHTML = '<i class="fas fa-save"></i> Salvar Prescrição';
            return;
        }

        // Get insumos
        const insumos = [];
        document.querySelectorAll('#insumos-presc-container > div[id^="insumo-presc-"]').forEach(row => {
            const nome = row.querySelector('.insumo-presc-nome')?.value;
            const dose = row.querySelector('.insumo-presc-dose')?.value;
            const unidade = row.querySelector('.insumo-presc-unidade')?.value;

            if (nome && dose) {
                insumos.push({
                    item: nome,
                    dose: parseFloat(dose),
                    unidade: unidade
                });
            }
        });

        // Calcular área total
        const areaTotal = this.calculateAreaTotal(variedades);

        // Calcular custo estimado
        const shared = window.FazendaRP.Pages.operacional.shared;
        const custoEstimado = await shared.calculatePrescriptionCost(insumos, areaTotal);

        const payload = {
            titulo: form.titulo.value,
            tipo_operacao: form.tipo.value,
            estadio_fenologico: form.estadio.value || null,
            data_inicio: form.data_inicio.value,
            data_fim: form.data_fim.value,
            variedades_ids: variedades,
            area_total_ha: areaTotal,
            insumos: insumos,
            objetivo: form.objetivo.value,
            custo_estimado: custoEstimado,
            status: 'Pendente'
        };

        try {
            const { error } = await window.FazendaRP.supabase
                .from('operacional_prescricoes')
                .insert([payload]);

            if (error) throw error;

            window.FazendaRP.Toast.show('success', 'Sucesso', `Prescrição criada! Custo estimado: R$ ${custoEstimado.toFixed(2)}`);
            document.getElementById('modal-prescricao').style.display = 'none';
            this.loadPrescricoes();

        } catch (err) {
            console.error(err);
            alert('Erro ao salvar: ' + err.message);
        } finally {
            btn.disabled = false;
            btn.innerHTML = '<i class="fas fa-save"></i> Salvar Prescrição';
        }
    },

    executarPrescricao: async function (prescricaoId) {
        try {
            const { data } = await window.FazendaRP.supabase
                .from('operacional_prescricoes')
                .select('*')
                .eq('id', prescricaoId)
                .single();

            window.FazendaRP.Pages.operacional.switchTab('diario');

            setTimeout(() => {
                const btnToggle = document.getElementById('btn-toggle-form');
                if (btnToggle && btnToggle.innerHTML.includes('Novo')) btnToggle.click();

                setTimeout(() => {
                    const form = document.getElementById('form-atividade');
                    if (!form) return;

                    if (data.tipo_operacao) form.tipo.value = data.tipo_operacao;
                    if (data.estadio_fenologico) form.estadio.value = data.estadio_fenologico;

                    if (data.variedades_ids) {
                        data.variedades_ids.forEach(vid => {
                            const cb = form.querySelector(`input[name="variedades"][value="${vid}"]`);
                            if (cb) { cb.checked = true; cb.dispatchEvent(new Event('change')); }
                        });
                    }

                    if (data.insumos) {
                        data.insumos.forEach((ins, i) => {
                            if (i > 0) window.FazendaRP.Pages.operacional.diario.addInsumoRow();
                            setTimeout(() => {
                                const rows = document.querySelectorAll('#insumos-container > div[id^="insumo-"]');
                                if (rows[i]) {
                                    rows[i].querySelector('.insumo-nome').value = ins.item || '';
                                    rows[i].querySelector('.insumo-dose').value = ins.dose || '';
                                    rows[i].querySelector('.insumo-unidade').value = ins.unidade || 'L/ha';
                                }
                            }, 100 * i);
                        });
                    }

                    if (data.custo_estimado > 0) {
                        form.custo_total.value = data.custo_estimado.toFixed(2);
                    }

                    window.FazendaRP.Toast.show('info', 'Carregado', 'Preencha data e observações');
                }, 400);
            }, 600);
        } catch (err) {
            alert('Erro: ' + err.message);
        }
    },

    cancelarPrescricao: async function (prescricaoId) {
        if (!confirm('Deseja realmente cancelar esta prescrição?')) return;

        try {
            const { error } = await window.FazendaRP.supabase
                .from('operacional_prescricoes')
                .update({ status: 'Cancelada' })
                .eq('id', prescricaoId);

            if (error) throw error;

            window.FazendaRP.Toast.show('success', 'Prescrição cancelada');
            this.loadPrescricoes();

        } catch (err) {
            console.error(err);
            alert('Erro ao cancelar: ' + err.message);
        }
    },

    exportarPDF: async function (prescricaoId) {
        try {
            // Fetch prescription data
            const { data: prescricao, error } = await window.FazendaRP.supabase
                .from('operacional_prescricoes')
                .select('*')
                .eq('id', prescricaoId)
                .single();

            if (error) throw error;

            // Import jsPDF
            const { jsPDF } = window.jspdf;
            const doc = new jsPDF();

            // Header
            doc.setFillColor(5, 150, 105);
            doc.rect(0, 0, 210, 40, 'F');

            doc.setTextColor(255, 255, 255);
            doc.setFontSize(22);
            doc.setFont(undefined, 'bold');
            doc.text('PRESCRIÇÃO AGRONÔMICA', 105, 20, { align: 'center' });

            doc.setFontSize(12);
            doc.setFont(undefined, 'normal');
            doc.text('Fazenda Rio do Peixe e Fartura', 105, 30, { align: 'center' });

            // Reset text color
            doc.setTextColor(0, 0, 0);

            // Prescription info
            let yPos = 50;
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.text('Informações da Prescrição', 20, yPos);

            yPos += 10;
            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');

            doc.text(`Título: ${prescricao.titulo}`, 20, yPos);
            yPos += 7;
            doc.text(`Tipo de Operação: ${prescricao.tipo_operacao}`, 20, yPos);
            yPos += 7;
            doc.text(`Janela de Aplicação: ${new Date(prescricao.data_inicio).toLocaleDateString('pt-BR')} - ${new Date(prescricao.data_fim).toLocaleDateString('pt-BR')}`, 20, yPos);
            yPos += 7;
            doc.text(`Status: ${prescricao.status}`, 20, yPos);

            if (prescricao.estadio_fenologico) {
                yPos += 7;
                doc.text(`Estádio Fenológico: ${prescricao.estadio_fenologico}`, 20, yPos);
            }

            yPos += 7;
            doc.text(`Área Total: ${prescricao.area_total_ha || 0} hectares`, 20, yPos);

            // Objective
            if (prescricao.objetivo) {
                yPos += 12;
                doc.setFont(undefined, 'bold');
                doc.text('Objetivo / Justificativa Técnica:', 20, yPos);
                yPos += 7;
                doc.setFont(undefined, 'normal');
                const splitText = doc.splitTextToSize(prescricao.objetivo, 170);
                doc.text(splitText, 20, yPos);
                yPos += (splitText.length * 5) + 5;
            }

            // Products table
            if (prescricao.insumos && prescricao.insumos.length > 0) {
                yPos += 10;
                doc.setFont(undefined, 'bold');
                doc.text('Produtos Prescritos', 20, yPos);
                yPos += 5;

                // Create table data
                const tableData = prescricao.insumos.map(insumo => {
                    const totalDose = (insumo.dose * (prescricao.area_total_ha || 0)).toFixed(2);
                    return [
                        insumo.item,
                        `${insumo.dose} ${insumo.unidade}`,
                        `${totalDose} ${insumo.unidade.replace('/ha', '')}`
                    ];
                });

                doc.autoTable({
                    startY: yPos,
                    head: [['Produto', 'Dose/ha', 'Total']],
                    body: tableData,
                    theme: 'grid',
                    headStyles: {
                        fillColor: [5, 150, 105],
                        textColor: [255, 255, 255],
                        fontStyle: 'bold'
                    },
                    styles: {
                        fontSize: 9,
                        cellPadding: 5
                    },
                    margin: { left: 20, right: 20 }
                });

                yPos = doc.lastAutoTable.finalY + 10;
            }

            // Cost
            if (prescricao.custo_estimado && prescricao.custo_estimado > 0) {
                yPos += 5;
                doc.setFillColor(236, 253, 245);
                doc.rect(20, yPos - 5, 170, 20, 'F');

                doc.setFont(undefined, 'bold');
                doc.setFontSize(12);
                doc.text('Custo Estimado:', 25, yPos + 5);

                doc.setTextColor(5, 150, 105);
                doc.setFontSize(14);
                const custoFormatted = prescricao.custo_estimado.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                });
                doc.text(custoFormatted, 185, yPos + 5, { align: 'right' });

                doc.setTextColor(0, 0, 0);
                doc.setFontSize(9);
                if (prescricao.area_total_ha && prescricao.area_total_ha > 0) {
                    const custoHa = (prescricao.custo_estimado / prescricao.area_total_ha).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    });
                    doc.text(`(${custoHa}/ha)`, 185, yPos + 11, { align: 'right' });
                }
            }

            // Footer
            doc.setFontSize(8);
            doc.setTextColor(100, 100, 100);
            doc.text(`Gerado em: ${new Date().toLocaleDateString('pt-BR')} às ${new Date().toLocaleTimeString('pt-BR')}`, 105, 285, { align: 'center' });

            // Save PDF
            const fileName = `Prescricao_${prescricao.titulo.replace(/[^a-zA-Z0-9]/g, '_')}_${new Date().getTime()}.pdf`;
            doc.save(fileName);

            window.FazendaRP.Toast.show('success', 'PDF Gerado', 'Prescrição exportada com sucesso!');

        } catch (err) {
            console.error('Erro ao gerar PDF:', err);
            alert('Erro ao gerar PDF: ' + err.message);
        }
    }
};
